<div
    class="fixed z-50 shadow-md bg-white rounded-xl p-2 max-h-[24.5rem] bottom-[21rem] overflow-y-scroll"
    id="picker"
    [class]="pickerPositionClass()"
    [class.picker-left.px]="pickerLeft()">
    <div class="flex flex-col gap-3">
        @for (type of pickerTypes(); track type) {
            <button
                class="select-card group footer-shadow hover:border-custom-blue border-solid"
                type="button"
                [class]="
                    hoveredType() === type ||
                    (picker()?.mode === PickerMode.PRIMARY && primaryBasemap() === type) ||
                    (picker()?.mode === PickerMode.SECONDARY_REPLACE && replacingSecondary() === type)
                        ? 'border-custom-blue'
                        : 'border-transparent'
                "
                (click)="onPick(type)"
                (mouseenter)="hoveredType.set(type)"
                (mouseleave)="hoveredType.set(null)">
                <div class="thumb w-36 h-24">
                    @if (!isBackground(type)) {
                        <img
                            alt=""
                            class="thumb-img"
                            [src]="catalog()[type].thumbnail!" />
                    } @else {
                        <div
                            class="thumb-bg"
                            [style.background]="catalog()[type].color"></div>
                    }
                    <div class="thumb-label pointer-events-none">
                        <div
                            class="hovered-message bg-white/70 transition-colors group-hover:bg-custom-light-blue group-hover:text-custom-blue">
                            {{ `basemapKey.${type}` | transloco }}
                        </div>
                    </div>
                </div>
            </button>
        }
    </div>
</div>
